module.exports = __webpack_public_path__ + "static/media/GT-Walsheim-Pro-Bold.ba11469f.OTF";